import request from '@/utils/request'

// 检查用户是否白名单
export function checkPinWhite() {
  return request({
    url: '/node/control/check',
    method: 'get'
  })
}

// 检查用户是否实名认证
export function checkRealNameAuth() {
  return request({
    url: '/node/control/name',
    method: 'get'
  })
}

// 节点列表
export function handleGetNodeList(data) {
  return request({
    url: '/node/control/list',
    method: 'post',
    data
  })
}

// 添加节点
export function handleAddNode(params) {
  return request({
    url: '/node/control/add',
    method: 'get',
    params
  })
}

// 编辑节点
export function handleEditNode(data) {
  return request({
    url: '/node/control/edit',
    method: 'post',
    data
  })
}

// 激活节点
export function handleGetActivateNode(params) {
  return request({
    url: '/node/control/activate',
    method: 'get',
    params
  })
}

// 绑定节点
export function handleBindingNode(params) {
  return request({
    url: '/node/control/binding',
    method: 'get',
    params
  })
}

